<template>
  <div class="content">
    <van-nav-bar title="商品详情" border fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#000" />
      </template>
    </van-nav-bar>
    <div class="detail-container">
      <div class="swipe-list">
        <van-swipe :autoplay="3000" :stop-propagation="false" indicator-color="white">
          <van-swipe-item
            v-for="(image, index) in images"
            :key="index"
            @click="handleImageClick(index)"
          >
            <!-- <img :src="detailModel.imageUrl" :alt="detailModel.shopFoodName" /> -->
            <van-image :src="image" fit="cover" class="img" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="food-info">
        <div class="name">{{ detailModel.shopFoodName }}</div>
        <div class="price">¥{{ getPrice }}</div>

        <div v-if="false" class="rate">
          <van-rate
            v-model="detailModel.rating"
            :size="25"
            allow-half
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
          />
        </div>
        <div v-if="false" class="sales-info">
          <span class="price">¥{{ getPrice }}</span>
          <span class="quantity">月售{{ detailModel.salesCount }}份</span>
        </div>
      </div>

      <div class="food-option">
        <div class="spec">
          <h2>规格</h2>
          <div class="option-list">
            <div
              v-for="(item, index) in detailModel.specList"
              :key="index"
              class="option"
              :class="{ active: item.checked }"
              @click="handleSpecChange(index)"
            >
              <span>{{ item.specName }}（¥{{ item.price }}）</span>
            </div>
          </div>
        </div>

        <div v-if="detailModel.cookList?.length" class="cooking">
          <div v-for="(item, index) in detailModel.cookList" :key="index" class="cooking-item">
            <h2>{{ item.cookName }}</h2>
            <div class="option-list">
              <div
                v-for="(info, idx) in item.valueList"
                :key="idx"
                class="option"
                :class="{ active: info.checked }"
                @click="handleSelectedCook(index, idx)"
              >
                <span>{{ info.value }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="num">
          <h2>数量</h2>
          <div class="">
            <van-stepper
              v-model="quantity"
              theme="round"
              button-size="30"
              disable-input
              :before-change="beforeChange"
            />
          </div>
        </div>
      </div>

      <div v-if="getDescription" class="food-desc" v-html="getDescription"> </div>

      <div v-if="false" class="recommend">
        <h2>猜你喜欢</h2>
        <div class="recommend-list-scroll">
          <div v-for="(item, index) in recommendList" :key="index" class="recommend-item">
            <van-image :src="item.imgUrl" radius="10px" class="recommend-img" />
            <div class="recommend-info">
              <h3 class="food-name">{{ item.name }}</h3>
              <p class="food-price">￥{{ item.price }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom border-top">
      <div class="cart" @click="handleGoToCart">
        <van-badge :content="cartCount">
          <i class="fas fa-shopping-cart text-2xl text-gray-600"></i>
        </van-badge>
      </div>
      <div class="button">
        <button class="ios-button" @click="handleAddToCart"> 加入购物车 ¥{{ getPrice }} </button>
      </div>
    </div>
  </div>

  <van-dialog
    v-model:show="showTableDialog"
    :show-confirm-button="false"
    :destroy-on-close="true"
    class="spec-dialog"
  >
    <div class="dialog-content">
      <van-icon name="close" class="close-icon" @click="handleScanClose" />
      <h3 class="dialog-title">提示</h3>
      <div class="spec-tags"> 请先扫桌号，然后进行点餐。 </div>

      <van-button round block color="#dc750e" class="confirm-btn" @click="handleGoScanQRCode">
        <span style="font-weight: bold; color: white">去扫码</span>
      </van-button>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue';
  import h5Config from '@/config/config';
  import router from '@/router';
  import { getCommodity } from '@/service/commodity';
  import { useRoute } from 'vue-router';
  import { CommodityModel } from '@/model/commdoity';
  import { fetchAddCart, fetchCartList } from '@/service/order';
  import useMainStore from '@/store/useMainStore';
  import { showDialog } from 'vant';
  import { CartModel } from '@/model/order';
  import { showImagePreview } from 'vant';

  const route = useRoute();
  const mainStore = useMainStore();
  const shopId = mainStore.getShopId;
  const customerId = mainStore.getcustomerId;
  const customerName = mainStore.getcustomerName;
  const foodId = ref(0);
  const quantity = ref(1);
  const detailModel = ref<CommodityModel>({});
  const images = ref<string[]>([]);
  const showTableDialog = ref(false);

  const getPrice = computed(() => detailModel.value.specList?.find((item) => item.checked)?.price);
  const getFoodCookDesc = computed(() => {
    let foodCookDesc = '';
    detailModel.value.cookList?.forEach((item) => {
      const list = item.valueList?.filter((info) => info.checked).map((info) => info.value) || [];
      if (list.length) {
        foodCookDesc += `${item.cookName}：${list.join('、')} | `;
      }
    });

    if (foodCookDesc?.endsWith(' | ')) {
      foodCookDesc = foodCookDesc.slice(0, -3);
    }
    return foodCookDesc;
  });

  const getDescription = computed(() =>
    detailModel.value.description
      ?.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      ?.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''),
  );

  onMounted(() => {
    foodId.value = Number(route.query.id);
    loadCommodity();
    loadCartData();
  });

  const loadCommodity = async () => {
    const res = await getCommodity({ shopFoodId: foodId.value, shopFoodStatus: 0 });
    detailModel.value = res.result || {};
    if (detailModel.value.specList?.length) {
      detailModel.value.specList.forEach((item, index) => {
        item.checked = index === 0;
      });
    }
    if (detailModel.value.cookList?.length) {
      detailModel.value.cookList?.forEach((item) => {
        item.valueList?.forEach((info) => {
          info.checked = false;
        });
      });
    }

    images.value = [detailModel.value.imageUrl || ''];

    // if (detailModel.value.foodName === '红烧狮子头') {
    //   detailModel.value.description = `
    //   <h2>菜品详情</h2>
    //   <p>
    //     红烧狮子头是一道经典的中式传统名菜，属于淮扬菜系。选用上等五花肉和新鲜猪肉馅，精心调配而成。肉质鲜嫩多汁，咸鲜适口，香味浓郁，入口即化，风味独特。
    //   </p>
    //   <h2>主要材料</h2>
    //   <p>猪肉、葱姜蒜、酱油、料酒、白糖</p>
    //   <h2>过敏原</h2>
    //   <p>大豆</p>`;
    // }
  };

  const cartList = ref<Array<CartModel>>([]);
  const cartCount = computed(() => {
    return cartList.value.reduce((sum, item) => sum + (item.count || 0), 0);
  });
  const loadCartData = async () => {
    const resp = await fetchCartList({
      pageNum: 1,
      pageSize: 999,
      data: { cartTag: mainStore.getCarTag() },
    });
    if (resp.code !== 200) {
      showDialog({ message: resp.msg });
    } else {
      cartList.value = [];
      resp.result.list.forEach((item: any) => {
        cartList.value.push({
          shopCartId: item.shopCartId,
          id: item.shopFoodId,
          count: item.quantity,
          price: item.price,
        });
      });
    }
  };

  // 热门菜品数据
  const recommendList = ref([
    {
      name: '北京烤鸭',
      price: 88,
      imgUrl:
        'https://images.unsplash.com/photo-1512058564366-18510be2db19?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
    {
      name: '水煮鱼',
      price: 68,
      imgUrl:
        'https://images.unsplash.com/photo-1563245372-f21724e3856d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
    {
      name: '宫保鸡丁',
      price: 52,
      imgUrl:
        'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
  ]);

  const handleSpecChange = (index: number) => {
    detailModel.value.specList?.forEach((item, i) => {
      item.checked = i === index;
    });
  };

  const handleSelectedCook = (cookIndex: number, selectedIndex: number) => {
    const cookItem = detailModel.value.cookList?.at(cookIndex);
    if (!cookItem) return;

    if (cookItem.cookType === 1) {
      detailModel.value.cookList?.at(cookIndex)?.valueList?.forEach((item, i) => {
        if (i === selectedIndex) {
          item.checked = !item.checked;
          return;
        }
      });
    } else if (cookItem.cookType === 2) {
      detailModel.value.cookList?.at(cookIndex)?.valueList?.forEach((item, i) => {
        item.checked = i === selectedIndex;
      });
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const handleGoToCart = () => {
    router.push('/cart');
  };

  const handleAddToCart = async () => {
    if (!mainStore.getShopId || !mainStore.getTableId || !mainStore.getQrCode) {
      showTableDialog.value = true;
      return;
    }
    showTableDialog.value = false;

    const specItem = detailModel.value.specList?.find((item) => item.checked);

    const resp = await fetchAddCart({
      shopId: shopId,
      tableId: mainStore.getTableId,
      cartTag: mainStore.getCarTag(),
      customerId: customerId,
      customerName: customerName,
      shopFoodId: detailModel.value.shopFoodId,
      shopFoodName: detailModel.value.shopFoodName,
      foodId: detailModel.value.foodId,
      foodName: detailModel.value.foodName,
      foodType: detailModel.value.foodType,
      shopFoodSpecId: specItem?.shopFoodSpecId,
      foodSpecName: specItem?.specName,
      foodCookDesc: getFoodCookDesc.value,
      quantity: 1,
      price: getPrice.value,
    });

    if (resp.code === 200) {
      router.push('/cart');
    } else {
      showDialog({ message: resp.msg });
      return;
    }
  };

  const handleImageClick = (index: number) => {
    // currentBigImage.value = imgSrc;
    // showImagePopup.value = true;

    showImagePreview({
      images: images.value,
      startPosition: index,
      closeable: true,
    });
  };

  const handleScanClose = () => {
    showTableDialog.value = false;
  };

  const handleGoScanQRCode = () => {
    router.replace('/scan');
  };

  const beforeChange = () => {
    if (!mainStore.getShopId || !mainStore.getTableId || !mainStore.getQrCode) {
      showTableDialog.value = true;
      return false;
    }
    showTableDialog.value = false;
    return true;
  };
</script>

<style scoped lang="less">
  .content {
    margin: 6px;
    height: 100%;
    overflow-x: hidden !important;
    overflow-y: auto !important;

    h2 {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 10px;
      text-align: left;
    }

    .detail-container {
      padding-bottom: 60px;
      box-sizing: border-box;
      overflow-y: auto;
    }

    .swipe-list {
      margin-top: 46px;

      .img {
        width: 100%;
        height: 288px;
      }
    }

    .food-info {
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      background-color: #fff;
      padding: 16px;

      .name {
        flex: 1;
        font-size: 20px;
        font-weight: 700;
        text-align: left;
        margin-bottom: 6px;
      }

      .price {
        font-size: 16px;
        font-weight: 700;
        color: #ef4444;
        line-height: 28px;
      }

      .rate {
        text-align: left;
        margin-bottom: 6px;
      }

      .sales-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .price {
          font-size: 20px;
          font-weight: 700;
          color: #ef4444;
          line-height: 28px;
        }

        .quantity {
          font-size: 14px;
          color: #999;
        }
      }
    }

    .food-option {
      margin-top: 10px;
      background-color: #fff;

      .option-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        font-size: 14px;

        .option {
          padding: 10px 16px;
          border: 1px solid #ccc;
          border-radius: 20px;
        }

        .active {
          background-color: v-bind('h5Config.themeColor');
          color: #fff;
          border-color: v-bind('h5Config.themeColor');
        }
      }

      .spec,
      .cooking {
        padding: 10px 16px 26px 16px;
        border-bottom: 0.5px solid #f4f1f1;
      }

      .num {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;

        ::v-deep .van-stepper--round .van-stepper__plus {
          background-color: v-bind('h5Config.themeColor');
        }

        ::v-deep .van-stepper--round .van-stepper__minus {
          color: v-bind('h5Config.themeColor');
          border: 1px solid v-bind('h5Config.themeColor');
        }

        // van-stepper van-stepper--round {
        //   background-color: v-bind('h5Config.themeColor');;
        //   color: #fff;
        // }

        van-stepper {
          background-color: v-bind('h5Config.themeColor');
        }

        ::v-deep .van-stepper__input {
          font-size: 22px;
        }
      }
    }

    .food-desc {
      padding: 16px;
      margin-top: 10px;
      background-color: #fff;
      text-align: left;
      font-size: 14px;
      overflow-y: auto !important;
      position: relative;
    }

    .recommend {
      padding: 16px;
      margin-top: 10px;
      background-color: #fff;
      margin-bottom: 100px;

      .recommend-list-scroll {
        display: flex;
        flex-wrap: nowrap;
        gap: 10px;
        padding: 10px 0;
        overflow-x: auto;

        .recommend-item {
          .recommend-img {
            width: 120px;
            height: 90px;
          }

          .recommend-info {
            text-align: left;
            font-size: 14px;
            .food-name {
            }
            .food-price {
              color: #ef4444;
            }
          }
        }
      }
    }

    .bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      z-index: 99;
      background-color: #fff;
      padding: 12px 16px;
      border: none;
      border-top: 1px solid #e5e7eb;

      .button {
        flex: 1;
        margin-left: 16px;
      }

      .ios-button {
        background-color: v-bind('h5Config.themeColor');
        color: #fff;
        border: none;
        border-radius: 10px;
        padding: 12px 16px;
        font-size: 16px;
        // font-weight: 700;
        text-align: center;
        width: 100%;
        border: none;
      }
    }

    .big-image {
      max-width: 100%;
      max-height: 80vh;
      object-fit: contain;
    }

    // ::v-deep.van-popup--center {
    //   background-color: #ef4444 !important;
    // }
    // ::v-deep .van-popup {
    //   background-color: #ef4444 !important;
    // }
  }

  .spec-dialog {
    .van-dialog__content {
      padding: 20px !important;
    }

    .dialog-content {
      position: relative; /* 关键：为关闭按钮提供定位基准 */
      text-align: left;
      padding: 20px !important;
    }
    .close-icon {
      position: absolute;
      top: 12px;
      right: 12px;
      font-size: 20px;
      color: #999;
      cursor: pointer;
      z-index: 10;
      padding: 4px;

      /* 添加悬停效果 */
      &:hover {
        color: #333;
        background: #f5f5f5;
        border-radius: 50%;
      }
    }

    .dialog-title {
      font-size: 16px;
      font-weight: bold;
      margin: 15px 0 10px 0;
    }

    .spec-tags,
    .method-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 15px;
    }

    .confirm-btn {
      margin-top: 20px;
      width: 100% !important;
    }
  }
</style>
